import Splide from "@splidejs/splide"

const sliders = {
  porductSliders: document.querySelectorAll(".jsProdSlider") as NodeListOf<HTMLElement>,
  heroSliders: document.querySelectorAll(".jsHeroSlide") as NodeListOf<HTMLElement>,
  init() {
    this.setHeroSliders()
    this.setProdSliders()   
  },
  setHeroSliders(){
    this.heroSliders.forEach((el) => {
      new Splide(el, {
        perPage: 1,
        type: "loop",   
        speed: 800,  
        arrows: false,
      }).mount()
    })
  },
  setProdSliders() {
    this.porductSliders.forEach((el) => {
      new Splide(el, {
        perPage: 3,
        type: "loop",
        pagination: false,  
        speed: 800,
        gap: '54px',
        padding: { left: '20px', right: '20px' },
        breakpoints: {
          920: {
            perPage: 2,  
               
          },
          500: {
            padding: { left: '20px', right: '23%' },
            perPage: 1,
            gap: '20px',
          },
        },
      }).mount()
    })
  },
}

export default sliders
